<template>
  <div>
    <div class="cover">
      <img :src="require('@/assets/we/banner.png')" alt="">
    </div>

    <div class="topTxt">
      <div class="hs">
        <div class="title">企业简介</div>
        <div class="txt">
          <p>
            四川米果码信息技术有限公司是一家专注于防伪溯源领域的高新技术企业，致力于通过技术创新赋能商品全链条数字化管理。公司以产品技术研发为核心驱动力，深度融合自动识别、自动控制、互联网及物联网技术，构建起覆盖商品全生命周期的智能管理体系。
          </p>
          <div class="product-title">公司核心产品矩阵包括：</div>
          <ul class="product-list">
            <li><strong>防伪标签：</strong>提供防破坏、防复制解决方案</li>
            <li><strong>经销商管理系统：</strong>优化渠道分销网络</li>
            <li><strong>CRM管理系统：</strong>强化客户关系管理</li>
            <li><strong>会员管理系统：</strong>构建精准用户画像</li>
            <li><strong>全流程追溯系统：</strong>实现原料入库到终端销售的全链路数据追踪</li>
            <li><strong>一物一码智能营销管理系统：</strong>通过单品赋码技术打通营销闭环</li>
          </ul>
          <p>
            为食品、医药、快消品等多个行业提供定制化的一物一码数字解决方案，助力企业实现数字化转型。
          </p>
        </div>
      </div>
    </div>


    <div class="cenBox">
      <div v-for="(v,i) in cenBoxList" :key="i">
        <span :class="['icon' ,v.icon]"></span>
        <div class="t">
          {{ v.title }}
          <div>{{ v.eg }}</div>
        </div>
      </div>
    </div>


    <div class="service">
      <div class="hs">
        <div class="txt">
          在不同行业、不同领域、不同场景下提供了全方位的解决方案与服务
        </div>
      </div>

      <img src="../../assets/we/dt.jpg" alt="">


      <div class="hs">
        <div class="title">资质荣誉</div>
        <div class="txt">
          我们已经获得了多项荣誉，荣获专利技术与证书
        </div>
      </div>

    </div>


    <div class="honor">
      <img src="../../assets/we/zz.png" alt="">
    </div>


    <div class="trust">

      <div class="hs">
        <div class="title">客户信赖</div>
        <div class="txt">
          万物互联，价值共享
        </div>
      </div>

      <img src="../../assets/we/kh.png" alt="">


      <div class="hs">
        <div class="title">客户信赖</div>
        <div class="txt">
          万物互联，价值共享
        </div>
      </div>
    </div>


    <div class="we">

      <div class="box">

        <img src="../../assets/we/d.png" alt="">

        <div class="contact">
          <div class="itme"><span class="icon icondianhua"></span>
            <span>400-099-0767</span>
          </div>
          <div class="itme"><span class="icon icondizhi"/> <span>成都市成华区成致路50号银龙国际11栋403号</span></div>
          <div class="itme"><span class="icon icongongzhonghao"/> <img src="../../assets/gzh.png" alt=""></div>
          <div class="itme">
            <div>
              <img src="../../assets/home/wx.png" alt="">
              <img src="../../assets/home/wb.png" alt="">
              <img src="../../assets/home/zf.png" alt="">
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>


import { scrolTop } from "@/utils/ decorator";

export default {
  components: {},
  data() {
    return {
      cenBoxList: [
        { icon: 'iconhangyeyoushi', title: '溯源集成服务', eg: 'TRACEABILITY SYSTEM' },
        { icon: 'iconruanjiankaifa', title: '软件开发', eg: 'SOFTWARE DEVELOPMENT' },
        { icon: 'iconerweima', title: '喷码机', eg: 'INKJET PRINTER' },
        { icon: 'iconshebeikaifa', title: '采集设备', eg: 'ACQUISITION EQUIPMENT' },
      ]
    }
  },
  name: "we",
  @scrolTop
  created() {
  },
}
</script>

<style lang="less" scoped>


.cover {
  width: 100%;
  height: 528px;
  img {
    width: 100%;
    height: 100%;
  }
}

.topTxt {
  padding: 100px 0 30px;
}

.hs {
  width: 1200px;
  margin: 0 auto;
  text-align: center;

  .title {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .txt {
    text-align: left;
    margin-top: 30px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;

    p {
      text-indent: 50px;
      line-height: 45px;
    }

    .product-title {
      margin-top: 20px;
      line-height: 45px;
      color: #333333;
    }

    .product-list {
      margin: 12px 0 20px;
      padding-left: 36px;
      line-height: 42px;

      strong {
        color: #333333;
      }
    }

  }
}


.cenBox {
  width: 100%;
  background: #F6F6F6;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 70px 230px;

  > div {
    width: 215px;
    padding: 45px 0;
    background: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 6px 26px 1px rgba(0, 0, 0, 0.03);

    .icon {
      width: 54px;
    }

    .t {
      margin-top: 40px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;

      > div {
        margin-top: 12px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FF5B5B;
      }
    }

  }

}

.service {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
  padding: 100px 0;

  .txt {
    text-align: center;
  }

  img {
    margin-top: 100px;
    width: 100%;
    height: 835px;
  }
}


.honor {
  text-align: center;
  background: #F6F6F6;
  padding: 66px 0;
}


.trust {
  padding: 100px 0 30px;
  text-align: center;

  .txt {
    text-align: center;
  }

  img {
    width: 1500px;
    margin: 80px 0 120px;
  }
}


.we {
  text-align: center;
  background: #F6F6F6;
  display: flex;
  justify-content: center;
  padding: 85px 0;

  .box {
    width: 700px;
    display: flex;
    justify-content: space-between;

    img {
      width: 372px;
      height: 268px;
    }

    .contact {
      .itme {
        display: flex;
        margin: 20px 0;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;

        .icon {
          font-size: 23px;
          color: #fd8888;
          margin-right: 10px;
        }

        img {
          width: 84px;
          height: 79px;
        }

        > div {
          img {
            width: 34px;
            height: 34px;
            margin: 0 10px;
          }
        }
      }
    }
  }
}

</style>
